"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../../components/Icons/index");

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  border: 0;\n  background-color: #f0f1f3;\n  width: 24px;\n  height: 24px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.15s ease-in-out;\n\n  svg.plus path {\n    fill: #8990a3;\n    transition: fill 0.15s ease-in-out;\n  }\n\n  svg.minus line {\n    stroke: #8990a3;\n    transition: stroke 0.15s ease-in-out;\n  }\n\n  &:hover {\n    background-color: ", ";\n\n    svg.plus path {\n      fill: white;\n    }\n\n    svg.minus line {\n      stroke: white;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var AddRemoveButton = function AddRemoveButton(_ref) {
  var added = _ref.added,
      onClick = _ref.onClick,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["added", "onClick", "className"]);

  return _react.default.createElement(Button, _extends({
    className: className,
    onClick: onClick
  }, otherProps), !added ? _react.default.createElement(_index.IconActionPlus, {
    className: "plus",
    size: 20
  }) : _react.default.createElement(_index.IconMinus, {
    className: "minus",
    size: 20
  }));
};

var Button = _styledComponents.default.button(_templateObject(), function (_ref2) {
  var theme = _ref2.theme;
  return theme.brand.primary;
});

AddRemoveButton.defaultProps = {
  added: false
};
AddRemoveButton.propTypes = {
  /** Set to true if the remove state should be shown. */
  added: _propTypes.bool.isRequired,

  /** onClick function to be executed when the button is clicked. */
  onClick: _propTypes.func.isRequired,

  /** Extra className to be added to the button. */
  className: _propTypes.string,

  /** Extra props. */
  otherProps: _propTypes.object
};
var _default = AddRemoveButton;
exports.default = _default;